/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { computeTenantsGetComputeTenant } from "../../funcs/computeTenantsGetComputeTenant.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetComputeTenantRequest$inboundSchema,
};

export const tool$computeTenantsGetComputeTenant: ToolDefinition<typeof args> =
  {
    name: "compute-tenants-get-compute-tenant",
    description: `Get a tenant

Cluster-administrator-only.`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] = await computeTenantsGetComputeTenant(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
